import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles({
	text: {
		whiteSpace: "break-spaces",
		maxWidth: "290px",
		wordWrap: "break-word"
	}
})

export default useStyles
